import { render } from "./UpcomingEventsPage.vue?vue&type=template&id=bc309532"
import script from "./UpcomingEventsPage.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__